$(function () {
    "use strict";

    // The main tour variable
    var tour;

    // Dont cache page responses (mainly for development)
    $.ajaxSetup({ cache: false });

    // Keep a reference to the tour content element
    var $tourContent = $('#tour-content');

    // Flag indicating if we're doing a screen shot
    var doingScreenshot = false;

    // See if the tour should auto-start
    var autoStart = $tourContent.data('autostart');

    // See if we are starting at a particular step by specifying the key
    var startAtStepKey = $tourContent.data('startatstepkey');

    // Setup tooltips for any content loaded
    $tourContent.tooltip({ selector: 'a[data-toggle="tooltip"]' });

    // Handle clicking on any anchor element in the tour content
    $tourContent.on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
        // Stop the event from bubbling up to other handlers
        e.stopPropagation();

        // See if the link contains one of our hotspots that is currently active
        // and if so then trigger the elements click event otherwise display a message
        // that the link isnt currently active.
        var $this = $(this);
        var $reflexChildren = $this.find('div.tour-step-element-reflex, div.tour-step-element-hotspot');
        if ($reflexChildren.length > 0) {
            $($reflexChildren[0]).trigger('click');
        }
        else {
            var step = $this.data('xs-step');
            if (step) {
                tour.goTo(step);
            }
            else {
                alert('This link is not functional at this point in the tour.');
            }
        }

        return true;
    });

    // Setup fullscreen mode if supported
    if (browserSupportsFullscreen()) {
        var fullscreenButton = $('#fullscreen-button');

        // Make the button visible;
        fullscreenButton.css('display', 'block');

        // Hook the click event of the fullscreen button to request full screen for the content
        fullscreenButton.on('click', function () {
            requestFullscreen($tourContent[0]);
        });

        // Hook the button in the generated content footer to exit full screen mode
        $tourContent.on('click', '#exit-fullscreen-button', function () {
            exitFullscreen();
        });

        // On a window resize reposition the footer when in fullscreen mode
        $(window).resize(function () {
            if (inFullscreenMode()) {
                positionFooter();
            }
        });

        // Handle the switch in and out of full screen mode
        document.addEventListener(getFullscreenChangeEventName(), function (e) {
            // When leaving full screen mode put footer back to normal positioning
            if (!inFullscreenMode()) {
                // Set the footer back to a static position
                $("#generated-footer").css({ position: 'static' });

            }
        });
    }

    // Handle whiteboard base click to hide and size stuff for screen capture
    $('#whiteboard-base').on('click', function (e) {
        // Only hide anything if the CTRL key is also pressed
        if (e.ctrlKey) {
            doingScreenshot = true;

            $('#contact-tab').css('display', 'none');
            $('#observer').css('display', 'none');
            $('#fullscreen-button').css('display', 'none');

            // If the ALT key is also pressed then fix the width and reduce the shadow
            if (e.ctrlKey && e.altKey) {
                $('#tourframe').css('width', '930px');
            }
        }
    });

    // Keep track of the last tour page that was loaded
    var lastTourPageLoaded = null;

    // Instance the tour
    tour = new Tour({
        // Name is used in CSS classes for the tour as a whole plus individual steps
        name: 'overview',
        onStart: function (tour) {
            // Log event that a tour has been started
            appInsights.trackEvent("TourStarted", { Name: tour._options.name });
        },
        onEnd: function (tour) {
            // Log event that a tour has been stopped
            appInsights.trackEvent("TourEnded", { Name: tour._options.name });

            // Return to the tours page
            if (!doingScreenshot) {
                return window.location.assign("/tours");
            }
        },
        onRequestFullscreen: function () {
            // Switch the tour content to full screen mode
            return requestFullscreen($('#tourframe')[0]/*$tourContent[0]*/);
        },
        steps: [
        // Step 0: Showing Hamburger
        {
            key: '',
            container: '#tour-content',
            placement: 'bottombar',
            content: '', // Deliberately the empty string so the popup doesnt even show for this page
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideHamburgerPartial');
            },
            onShown: function (tour) {
                // Load the global overview process image in anticipation of going to that next
                PreloadModelImage('uuid_DD7CB4D0-45B2-45AF-8F9C-38F1CD8A9A6D_view_p0.png');
            }
        },
        // Step 1: Showing global slide
        {
            key: 'visualization-global',
            container: '#tour-content',
            hotspots: [{ element: '#us', step: 2 }],
            next: -1,
            placement: 'bottombar',
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideGlobalPartial');
            },
            onShown: function () {
                // Load the USA overview process image in anticipation of going to that next
                PreloadModelImage('uuid_078A107B-091B-4260-9206-7F3095ABFB72_view_p0.png');
            }
        },
        // Step 2: Showing USA slide
        {
            key: 'visualization-usa',
            container: '#tour-content',
            hotspots: [{ element: '#factory-houston', step: 3 }, { element: '#distribution-harrisburg', step: 4 }],
            placement: 'bottombar',
            nextSection: 9,
            nextSectionTitle: 'Next: One Click Access',
            next: -1,
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideUsaPartial');
            },
            onShown: function () {
                // Load the factory/warehouse process images in anticipation of going to there next
                PreloadModelImage('uuid_9564A85D-DFE1-472A-B5F4-9439678B7307_view_p0.png');
                PreloadOverviewImage('factory-no-flow-opt.png');
                PreloadOverviewImage('factory-yellow-flow-opt.png');
                PreloadOverviewImage('factory-blue-flow-opt.png');
                PreloadOverviewImage('factory-green-flow-opt.png');
            }
        },
        // Step 3: Showing factory slide
        {
            key: 'visualization-factory',
            container: '#tour-content',
            hotspots: [{ element: '#sales-office', step: 5 }],
            placement: 'bottombar',
            next: -1,
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                // Animate the flows
                $('img[data-xs-animation]').addClass('fade-in-out');

                // Load the sales office process images in anticipation of going to there next
                PreloadModelImage('uuid_D630FEE6-3AB3-49B5-9CB8-3EBC8AAEC9BC_view_p0.png');
            }
        },
        // Step 4: Showing warehouse slide
        {
            key: 'visualization-warehouse',
            container: '#tour-content',
            hotspots: [{ element: '#accounts-office', step: 7 }],
            placement: 'bottombar',
            prev: 2,
            next: -1,
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWarehousePartial');
            },
            onShown: function () {
                // Load the accounts office process images in anticipation of going to there next
                PreloadModelImage('uuid_8372BF92-CBDF-460D-9D7A-CFB9095BFBA4_view_p0.png');
            }
        },
        // Step 5: Showing sales office slide
        {
            key: 'visualization-salesoffice',
            container: '#tour-content',
            hotspots: [{ element: '#sales-order-form', step: 6 }],
            placement: 'bottombar',
            prev: 3,
            next: -1,
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideSalesOfficePartial');
            },
            onShown: function () {
                /* In case we go back to this slide from the next */
                hideAllPopups('Navigate to office and desk level');
            }
        },
        // Step 6: Showing sales office slide with order entry screen
        {
            key: 'visualization-orderentry',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 5,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideSalesOfficePartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Access ERP/CRM functions');
                /* Display the form  */
                displayPopup('#sales-order-entry-form', 2);
            }
        },
        // Step 7: Showing accounts office slide
        {
            key: 'visualization-accountsoffice',
            container: '#tour-content',
            hotspots: [{ element: '#senior-accountant', step: 8 }],
            placement: 'bottombar',
            content: ' ',
            prev: 4,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideAccountsOfficePartial');
            },
            onShown: function () {
                /* In case we go back to this slide from the next */
                hideAllPopups('Mimic the employees’ real world');
            }
        },
        // Step 8: Showing accounts office office slide with spreadsheet
        {
            key: 'visualization-spreadsheet',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 7,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideAccountsOfficePartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Access spreadsheets and other software');
                /* Display the form  */
                displayPopup('#accounts-spreadsheet', 2);
            }
        },
        // Step 9: Showing Factory slide
        {
            key: 'visualization-oneclickaccess',
            container: '#tour-content',
            hotspots: [
                { element: '#machining', step: 10 },
                { element: '#qaform', step: 11 },
                { element: '#shipping', step: 12 },
                { element: '#shipping-website', step: 13 },
                { element: '#sales-process', step: 14 },
                { element: '#purchasing-desk', step: 15 },
                { element: '#planning-desk', step: 16 }
            ],
            placement: 'bottombar',
            nextSection: 18,
            nextSectionTitle: 'Next: Workflow',
            prev: -1,
            next: -1,
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* In case we go back to this slide from the next */
                hideAllPopups('One click access to documents and software');

                // Load the factory workflow image in anticipation of going to there next
                PreloadModelImage('factory-workflow-opt.png');
            }
        },
        // Step 10: Showing factory slide with SOP form
        {
            key: 'visualization-sopform',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('How to perform work');
                /* Display the sop form  */
                displayPopup('#sop-form', 9);
            }
        },
        // Step 11: Showing factory slide with QA form
        {
            key: 'visualization-qaform',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Forms to be completed');
                /* Display the QA form */
                displayPopup('#qa-form', 9);
            }
        },
        // Step 12: Showing factory slide with packing video
        {
            key: 'visualization-packingvideo',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Show instructional videos');
                /* Display the packing video */
                displayPopup('#shipping-video', 9);
            }
        },
        // Step 13: Showing factory slide with shipping website
        {
            key: 'visualization-shippingwebsite',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Enable access to other systems');
                /* Display the shipping website */
                displayPopup('#shipping-website-image', 9);
            }
        },
        // Step 14: Showing factory slide with sales process
        {
            key: 'visualization-salesprocess',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Access end-to-end Processes');
                /* Display the sales process */
                displayPopup('#sales-process-image', 9);
            }
        },
        // Step 15: Showing factory slide with buyer role
        {
            key: 'visualization-buyerrole',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Show processes for a Role');
                /* Display the buyer role */
                displayPopup('#buyer-role-image', 9);
            }
        },
        // Step 16: Showing factory slide with purchasing process
        {
            key: 'visualization-purchasingprocess',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            hotspots: [{ element: '#requisition-stage', step: 17 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Access a procss stage');
                /* Display the purchasing process */
                $('#purchasing-process-image').fadeIn(900);
            }
        },
        // Step 17: Showing factory slide with purchasing process and create requisition stage
        {
            key: 'visualization-requisitionstage',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: 9,
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Access the tasks in a stage');
                /* Display the purchasing process in case we came directly to this step */
                $('#purchasing-process-image').css('display', 'block');
                displayPopup('#requisition-stage-image', 9);
            }
        },
        // Step 18: Showing factory workflow 
        {
            key: 'workflow',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            prev: -1,
            hotspots: [{ element: '#take-order', step: 19 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideFactoryWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Overlay process workflow');

                // Load the process flow image in anticipation of going to there next
                PreloadModelImage('process-workflow.jpg');
            }
        },
        // Step 19: Showing Process Flow 
        {
            key: 'workflow-designprocess',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#take-order', step: 20 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Design Process Workflow (Desk to desk)');
            }
        },
        // Step 20: Showing Process Flow and stage flow 
        {
            key: 'workflow-designstage',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#complete-order', step: 21 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Define the Tasks done at the Desk and in each Stage of the Process');
                displayAdditionalImage('#take-order-stage');
                ScrollToBottomOfContent(); 
            }
        },
        // Step 21: Showing Process Flow, stage flow, and notes popup
        {
            key: 'workflow-designstage-tasknotes',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Add User defined Notes and Metrics');
                displayAdditionalImage('#take-order-stage');
                ScrollToBottomOfContent();
                displayPopup('#task-notes-image', 22);
            }
        },
        // Step 22: Showing Process Flow to create new stage
        {
            key: 'workflow-create',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#create-workflow', step: 23 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Changing Process Workflow is easy');
                hideAdditionalImage('#take-order-stage');
                hideAdditionalImage('#modified-processflow');
                ScrollToTopOfContent();
            }
        },
        // Step 23: Showing modified Process Flow
        {
            key: 'workflow-create-newflow',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#take-order', step: 24 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Drag & drop predefined functions to create complex workflows');
                hideAdditionalImage('#take-order-stage');
                displayAdditionalImage('#modified-processflow');
            }
        },
        // Step 24: Showing Process Flow and stage flow
        {
            key: 'workflow-designstage-capturephoto',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#printer-photo', step: 25 }, { element: '#screen-photo', step: 26 }],
            nextSection: 27,
            nextSectionTitle: 'Next: Knowledgebase',
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Use a camera for quick detail capture');
                hideAdditionalImage('#modified-processflow');
                displayAdditionalImage('#take-order-stage');
                ScrollToBottomOfContent(); 

                // Load the role matrix image in anticipation of going to there next
                PreloadModelImage('rolematrix-base-opt.png');
            }
        },
        // Step 25: Showing Process Flow, stage flow and printer popup
        {
            key: 'workflow-designstage-printerphoto',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Attach Photos for each task in a stage');
                hideAdditionalImage('#modified-processflow');
                displayAdditionalImage('#take-order-stage');
                ScrollToBottomOfContent();
                displayPopup('#printer-image', 24);
            }
        },
        // Step 26: Showing Process Flow, stage flow and screen image
        {
            key: 'workflow-designstage-screenphoto',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideWorkflowPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Capture existing computer system details');
                hideAdditionalImage('#modified-processflow');
                displayAdditionalImage('#take-order-stage');
                ScrollToBottomOfContent();
                displayPopup('#screen-image', 24);
            }
        },
        // Step 27: Showing Role Matrix Report
        {
            key: 'knowledgebase-rolematrix',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#distribution-rolegroup', step: 28 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideRoleMatrixReportPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('The Role Matrix Report - See Who does What');
                hideAdditionalImage('#distribution-image');
                hideAdditionalImage('#purchasing-image');
            }
        },
        // Step 28: Showing Role Matrix Report and distribution role group
        {
            key: 'knowledgebase-rolematrix-distribution',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#purchasing-processgroup', step: 29 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideRoleMatrixReportPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('See where Distribution roles are used in Sales?');
                hideAdditionalImage('#purchasing-image');
                displayAdditionalImage('#distribution-image', 100);

                // Scroll to he bottom after a delay
                window.setTimeout(function () { ScrollToBottomOfContent(); }, 2000);
        }
        },
        // Step 29: Showing Role Matrix Report, distribution role group, and Purchasing Process Group
        {
            key: 'knowledgebase-rolematrix-purchasing',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            nextSection: 30,
            nextSectionTitle: 'Next: Analytics Matrix',
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideRoleMatrixReportPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('See what roles are employed in Purchasing');
                displayAdditionalImage('#distribution-image', 100);
                displayAdditionalImage('#purchasing-image', 100);
                ScrollToTopOfContent('#purchasing-image');

                // Load the note matrix image in anticipation of going to there next
                PreloadModelImage('notematrix-base-opt.png');
            }
        },
         // Step 30: Showing Note Matrix Report
        {
            key: 'knowledgebase-analyticsmatrix',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#apap-process', step: 31 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideNotesReportPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('The Analytics Matrix Report - See where to improve');
                hideAdditionalImage('#apap-process-image');
                hideAdditionalImage('#rei-stage-image');
            }
        },
        // Step 31: Showing Note Matrix Report with process expanded
        {
            key: 'knowledgebase-analyticsmatrix-process',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#rei-stage', step: 32 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideNotesReportPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Drill down to see each desk and each Stage of the Process');
                hideAdditionalImage('#rei-stage-image');
                displayAdditionalImage('#apap-process-image', 100);
            }
        },
        // Step 32: Showing Note Matrix Report with process and stage expanded
        {
            key: 'knowledgebase-notesmatrix-stage',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            nextSection: 33,
            nextSectionTitle: 'Next: Process Conformance',
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideNotesReportPartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Drill down to see tasks');
                displayAdditionalImage('#apap-process-image', 100);
                displayAdditionalImage('#rei-stage-image', 100);

                // Load the process conformance image in anticipation of going to there next
                PreloadModelImage('process-conformance-opt.png');
            }
        },
        // Step 33: Showing Process Compliance
        {
            key: 'knowledgebase-conformance',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            nextSection: 34,
            nextSectionTitle: 'Next: Process Improvement',
            next: -1,
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideProcessConformancePartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Process conformance – for any compliance regime');

                // Load the process improvement image in anticipation of going to there next
                PreloadModelImage('process-improvement-opt.png');
            }
        },
        // Step 34: Showing Process Improvement
        {
            key: 'knowledgebase-improvement',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            hotspots: [{ element: '#rei-stage', step: 35 }],
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideProcessManipulationPartial');
            },
            onShown : function () {
                /* Change the caption */
                hideAllPopups('Process manipulation - See where to improve');

                // Load the process imrovement stage image in anticipation of going to there next
                PreloadModelImage('process-improvement-stage-opt.png');
            }
        },
        // Step 35: Showing Process Improvement Stage flow
        {
            key: 'knowledgebase-improvement-stageflow',
            container: '#tour-content',
            placement: 'bottombar',
            content: ' ',
            onShow: function (tour, i) {
                return LoadTourPage(tour, i, '_SlideProcessManipulationStagePartial');
            },
            onShown: function () {
                /* Change the caption */
                hideAllPopups('Process manipulation - See where to improve');
            }
        }
        ],
        /* Turn off auto scrolling as we are displaying on a scrolling 'page' within the main page */
        autoscroll: true,
        container: 'body',
        keyboard: true,
        debug: false,
        storage: false,
        orphan: true,
        duration: false,
        delay: false,
        hotspotCssClass: 'tour-step-element-ring',
        template: function (i, step) {
            var result = '<div class="popover" role="tooltip">' +
                '<div class="arrow"></div>' +
                '<div class="popover-content" style="display: none;"></div>' +
                '<div class="popover-navigation">' +
                    '<div class="btn-toolbar pull-right" role="toolbar">';
            if (step.nextSection >= 0 || step.prevSection >= 0) {
                result += '<div class="btn-group" role="group">';
                
                if (step.prevSection >= 0) {
                    var prevSectionTitle = step.prevSectionTitle ? step.prevSectionTitle : 'Prev Section';
                    result += '<button class="btn btn-lg btn-primary" data-role="prev-section"><i class="fa fa-angle-double-left fa-lg" aria-hidden="true"></i>&ensp;' + prevSectionTitle + '</button>&nbsp;';
                }

                if (step.nextSection >= 0) {
                    var nextSectionTitle = step.nextSectionTitle ? step.nextSectionTitle : 'Next Section';
                    result += '<button class="btn btn-lg btn-primary" data-role="next-section">' + nextSectionTitle + '&ensp;<i class="fa fa-angle-double-right fa-lg" aria-hidden="true"></i></button>&nbsp;';
                }
                result += '</div>';
            }

            result +=
                        '<div class="btn-group" role="group">' +
                            '<button title="End the Tour" class="btn btn-lg btn-primary" data-role="end"><i class="fa fa-eject" aria-hidden="true"></i>&ensp;</button>' +
                        '</div>';
                    '</div>' +
                '</div>' +
            '</div>';

            return result;
        },
        onTrace: function (tour, step) {

            // Log an event to Application Insights giving details about the tour step displayed
            appInsights.trackEvent("TourStep", { Name: tour._options.name, Step: step.key });
        }
    });

    // Add a reference to the tour variable on the body so we can interogate it later 
    $('body').data('xs-tour', tour);

    // Start at the beginning by default 
    var startAtStep = 0;

    // If a start key has been specified see if we can find the matching step and update the step to start with
    if (startAtStepKey) {
        // Find a step with a matching key
        for (var i = 0, len = tour._options.steps.length; i < len; i++) {
            if (tour._options.steps[i].key === startAtStepKey)
            {
                // Specify that we will start at this step
                startAtStep = i;
                break;
            }
        }
    }

    // When this script runs the page that hosts the tour is being loaded which means we came from a real URL
    // and dont need to push the URL to the browser history.
    tour.pushHistoryUrl = false;

    // Setup the tour to start at the appropriate step
    if (startAtStep !== 0) {
        // But when starting from a particular step we dont need to push the history URL
        tour.setCurrentStep(startAtStep);
    }

    // Initialize the tour
    tour.init();

    // Either start the tour straight away or handle the start button click
    if (autoStart) {
        // Start the tour
        if (tour.ended()) {
            tour.restart();
        }
        else {
            tour.start(true);
        }
    } else {
        // Hook up a handler onto the start tour button
        $('#tour-start').on('click', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) {
                return;
            }
            $(this).addClass('disabled');

            if (tour.ended()) {
                tour.restart();
            }
            else {
                tour.start(true);
            }
        });
    }

    // Load content for a tour page into the appropriate element
    function LoadTourPage(tour, i, pageName, params) {

        // Build up the history URL for the step
        var step = tour._options.steps[i];
        var historyUrl = '/tours/overview';
        var pageTitle = 'Overview Tour ';
        if (step.key && step.key.length > 0) {
            var path = step.key.replace(/-/g, '/');
            historyUrl += '/' + path;
            pageTitle += '- ' + path + ' ';
        }
        pageTitle += '• XSOL';
        var historyObj = { type: 'tour', name: tour._options.name, stepKey: step.key, stepIndex: i, pageTitle: pageTitle, url: historyUrl };

        // Dont load the page if the requested page is already loaded.
        // Note: Each step tries to load the page it uses so that going back to a previous or random
        // step will load to appropriate content.
        if (lastTourPageLoaded === pageName) {

            // Push an entry to the browser history so we can see the URL and come back if requested
            if (tour.pushHistoryUrl && supportsHistoryApi()) {
                history.pushState(historyObj, '', historyUrl);
                if (tour._options.debug) {
                    console.debug('Push existing page: ' + historyObj.type + ', ' + historyObj.name + ', ' + historyObj.step + ', ' + historyUrl);
                }

                // Update the title of the page
                document.title = historyObj.pageTitle;

                // Log this as a page view so it appears in the analytics 
                appInsights.trackPageView(historyUrl, document.URL);
            }

            return;
        }

        var url = '/tours/overview/page/' + pageName;
        if (params) {
            url = url + '?' + params;
        }
        var dfd = $.Deferred();
        var tourContentDiv = $('#tour-content');

        if (tour._options.debug) {
            console.debug('XSOL: Set page loading..');
        }

        // Show loading...
        tourContentDiv.html('<div class="center-content-both"><p class="text-center"><i class="fa fa-circle-o-notch fa-4x fa-spin"></i><br />Loading...</p></div>');

        // Load the page content
        tourContentDiv.load(url, function (response, status, xhr) {
            if (status === 'success' || status === 'notmodified') {
                if (tour._options.debug) {
                    console.debug('XSOL: Page loaded');
                }

                // Remember the current page
                lastTourPageLoaded = pageName;

                // Manipulate the browser history if supported
                if (supportsHistoryApi()) {
                    if (tour.pushHistoryUrl) {
                        // Push an entry to the browser history so we can see the URL and come back if requested
                        history.pushState(historyObj, '', historyUrl);
                    }
                    else {
                        // Update the entry for the browser history adding state information so we can come back if requested
                        history.replaceState(historyObj, '', historyUrl);
                    }

                    // Update the title of the page
                    document.title = historyObj.pageTitle;

                    // Add debug message
                    if (tour._options.debug) {
                        console.debug((tour.pushHistoryUrl ? 'Push' : 'Replace') + ' new page: ' + historyObj.type + ', ' + historyObj.name + ', ' + historyObj.step + ', ' + historyUrl);
                    }
                }

                // For subsequent steps in this tour instance we need to push the history URL
                tour.pushHistoryUrl = true;

                // When in full screen mode adjust the position of the footer for 'short' pages
                if (inFullscreenMode()) {
                    positionFooter();
                }

                // Scroll to the top of the page
                $('#tour-content').animate({ scrollTop: 0 }, 0, function () {
                    if (tour._options.debug) {
                        console.debug('XSOL: Page scrolled');
                    }

                    // Loading is done
                    dfd.resolve();
                });
            } else {
                // Log an event to Application Insights 
                appInsights.trackEvent("TourPageLoadFailed", { PageUrl: url, Status: xhr.status, Response: xhr.responseText });

                // Page load failed so show an error
                $('#tour-content').html('<div class="center-content-both"><p class="text-center text-danger"><i class="fa fa-exclamation-circle fa-4x"></i><br />Page ' + pageName + ' for the visualization tour failed to load.<br/>Please contact XSOL to report the issue.</p></div>');
                dfd.reject();
            }
        });

        // Return the promise to ensure the calling code waits
        return dfd.promise();
    }

    // For pages without much content we may need to push the footer to the bottom of the page
    function positionFooter() {
        var $footer = $('#fullscreen-footer');

        if (($('#presentation-content').children().innerHeight() + $footer.height()) < $('#presentation-content').height()) {
            $footer.css({
                position: 'absolute'
            }).css({
                bottom: '0px'
            });
        } else {
            $footer.css({
                position: 'static'
            });
        }
    }

    // To help speed up navigation to the next page we can load the overview image for the page into the cache
    function PreloadOverviewImage(src) {
        if (tour._options.debug) {
            console.debug('XSOL: Pre-load overview image ' + src);
        }
        var image = new Image();
        image.src = '/Images/tour/overview/' + src;
    }

    // To help speed up navigation to the next page we can load the model image for the page into the cache
    function PreloadModelImage(src) {
        if (tour._options.debug) {
            console.debug('XSOL: Pre-load model image ' + src);
        }
        var image = new Image();
        image.src = '/Images/tour/model/' + src;
    }

    function ScrollToTopOfContent(elementId) {
        var dfd = $.Deferred();

        // If an element id is supplied then find its offset from the top
        var scrollPos = 0;
        var $element = $(elementId);
        if ($element.length === 1) {
            scrollPos = $element[0].offsetTop;
        }

        // Scroll so the element is displayed at the top
        $('div.slide-content').animate({ scrollTop: scrollPos }, 600, function () {
            dfd.resolve();
        });

        return dfd.promise();
    }

    function ScrollToBottomOfContent() {
        var dfd = jQuery.Deferred();

        $('div.slide-content').animate({ scrollTop: $('div.slide-content')[0].scrollHeight }, 1200, function () {
            dfd.resolve();
        });

        return dfd.promise();
    }

    function browserSupportsFullscreen() {
        return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }

    function inFullscreenMode() {
        return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }

    function requestFullscreen(element) {
        var rfs = element.requestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
        if (typeof rfs !== 'undefined' && rfs) {
            rfs.call(element);
        } else if (typeof window.ActiveXObject !== 'undefined') {
            // for Internet Explorer
            var wscript = new ActiveXObject('WScript.Shell');
            if (wscript !== null) {
                wscript.SendKeys('{F11}');
            }
        }
    }

    function exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }

    function getFullscreenChangeEventName() {
        if (document.fullscreenEnabled) {
            return 'fullscreenchange';
        } else if (document.webkitFullscreenEnabled) {
            return 'webkitfullscreenchange';
        } else if (document.mozFullScreenEnabled) {
            return 'mozfullscreenchange';
        } else {
            return 'MSFullscreenChange';
        }
    }

    function keyboardEquivalentsText() {
        var shortcuts = '<dt><kbd><i class="fa fa-long-arrow-left" aria-hidden="true"></i></kbd> , <kbd><i class="fa fa-long-arrow-right" aria-hidden="true"></i></kbd></dt><dd>Navigate backwards and forwards through the tour.</dd><dt><kbd>e</kbd></dt><dd>End the tour at it&apos;s current step.</dd>';
        if (browserSupportsFullscreen()) {
            shortcuts += '<dt><kbd>Enter</kbd></dt><dd>Enter full screen mode.</dd><dt><kbd>Esc</kbd></dt><dd>Leave full screen mode.</dd>';
        }

        return '<div class="keyboard-shortcuts"><p>Keyboard shortcuts:</p><dl class="dl-horizontal">' + shortcuts + '</dl></div>';
    }

    // Display the element with the id supplied 
    function displayAdditionalImage(additionalImageId, delay) {
        if (!delay) {
            delay = 800;
        }

        // Find the element with the id supplied and fade it in
        var $additionalImage = $(additionalImageId);
        $additionalImage.fadeIn(800);
    }

    // Hide the element with the id supplied 
    function hideAdditionalImage(additionalImageId) {
        // Find the element with the id supplied and hide it
        var $additionalImage = $(additionalImageId);
        $additionalImage.css('display', 'none');
    }

    // Display the element with the id supplied and position the close button over the top right edge.
    // When the close button is pressed then go to the specified step in the tour.
    function displayPopup(popupId, stepToReturnTo) {

        // Find the element with the id supplied and fade it in
        var $popup = $(popupId);
        $popup.fadeIn(800);

        // Find the close button
        var $button = $('#close-button');

        // Find the position of the popup element
        var $popupPosition = $popup.position();

        // Display the close button over the top right corner of the popup element
        $button.css('top', $popupPosition.top).css('left', $popupPosition.left + $popup.outerWidth()).css('display', 'block');

        // Handle the close button click event and go to the specified step
        $('#close-button, ' + popupId).off('click').click(function () {
            tour.goTo(stepToReturnTo);
        });
    }

    // Make sure any popups from previous steps are hidden
    function hideAllPopups(subtitle) {
        // Hide the close button
        $('#close-button').css('display', 'none');

        /* Hide all popup elements */
        $('[data-xs-popup]').css('display', 'none');
        $('img.popup-image').css('display', 'none');

        // Update the slide sub-title if requested
        if (subtitle) {
            $('#figure-caption').text(subtitle);
        }
    }
}
);

